module.exports = __webpack_public_path__ + "media/images/details__prizeBox__season__first-8e9ac74befd8e3d292263db01ffb8509.png";